import styles from "./Row.module.scss"

export default function Row(props) {
  return (
    <div className={`${styles.row} ${props.className ? props.className : ""}`}>
      {props.children}
    </div>
  )
}
